import { useState, useEffect } from 'react';

export function useList(init = null, handlers: any = {}) {
	const [list, setList] = useState<any>(init && Array.isArray(init) ? init : []);

	// useEffect(() => {
	// 	if (init && Array.isArray(init)) setList(init);
	// }, [init]);

	const onItemRemove = index => {
		let newList = list.filter((_, itemIndex) => itemIndex !== index);
		let removedItem = list.find((_, itemIndex) => itemIndex === index);
		if (handlers.onRemove) {
			handlers.onRemove(removedItem, index, newList, list);
			return setList(newList);
		}
		return setList(newList);
	};

	const onItemAdd = item => {
		let newList = [...list, item];
		if (handlers.onAdd) {
			handlers.onAdd(item, newList, list);
			return setList(newList);
		}
		return setList(newList);
	};

	const onItemChange = (index, newItem) => {
		// let newList = list.map((item, itemIndex) => {
		// 	if (itemIndex === index) return newItem;
		// 	return item;
		// });
		let newList = [...list];
		newList[index] = newItem;
		return setList(newList);
	};
	return [list, onItemAdd, onItemRemove, onItemChange, setList];
}
